import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_label_post_link_RowClass} from '../../../dbschema';



export class CmsLabelPostLinkContainerModel extends BaseContainerModel {

  bl_cms_label_post_link: bl_cms_label_post_link_RowClass = new bl_cms_label_post_link_RowClass();
}
